/* istanbul ignore file
NOTE: Function coverage dropped as we are passing empty function and not using it.
Will be addressed and removed in the linked ticket below
*/
import Button from '@mui/material/Button';

import { useSlug } from 'reservations/account/providers/ConfigProvider';
import { getMenuPageUrl } from 'reservations/base/helpers/routes';
import { useCustomRouter } from 'reservations/base/providers/RouterProvider';
import { OUR_MENU_SUBHEADER } from 'reservations/checklessPayments/constants';
import BookingConfirmationDetailCard from 'reservations/confirmation/components/BookingConfirmationDetailCard';
import BookingConfirmationDetailText from 'reservations/confirmation/components/BookingConfirmationDetailText';

const MenuModule = () => {
  const { handleNavigation } = useCustomRouter();
  const slug = useSlug();

  const handleClick = () => {
    const navUrl = getMenuPageUrl(slug);
    handleNavigation(navUrl);
  };

  return (
    <BookingConfirmationDetailCard header="Our Menu">
      <BookingConfirmationDetailText text={OUR_MENU_SUBHEADER} />
      <Button onClick={handleClick}>View Menu</Button>
    </BookingConfirmationDetailCard>
  );
};

export default MenuModule;
